type AuthDebugDetails = Record<string, unknown> | undefined;

const AUTH_DEBUG_STORAGE_KEY = "activityviz_debug_auth";

const isLocalHostname = (hostname: string) =>
  hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";

const isAuthDebugEnabled = () => {
  if (typeof window === "undefined") {
    return false;
  }

  if (isLocalHostname(window.location.hostname)) {
    return true;
  }

  const params = new URLSearchParams(window.location.search);
  if (params.get("debugAuth") === "1") {
    return true;
  }

  if (window.localStorage.getItem(AUTH_DEBUG_STORAGE_KEY) === "1") {
    return true;
  }

  return false;
};

export const authDebug = (event: string, details?: AuthDebugDetails) => {
  if (!isAuthDebugEnabled()) {
    return;
  }

  console.warn(`[AuthDebug] ${new Date().toISOString()} ${event}`, details ?? {});
};
